import React from 'react';
import { lDagre, updateNodeWidth } from '../../scripts/cy-core';
import IntegerSlider from '../../../IntegerSlider';
import { Col, Row, Space } from 'antd';
import { useSelector } from 'react-redux';

const ResizeBtn = () => {
  const config = useSelector((state) => state.tree.config);

  const onChangeSpacingFactor = (newValue) => {
    // const spacingFactor = newValue;
    // // debug-console.log('onChangeSpacingFactor: ', newValue);
    lDagre(null, { newValue });
  };

  const onChangeNodeWidth = (newValue) => {
    // // debug-console.log('onChangeNodeWidth: ', newValue);
    updateNodeWidth(newValue * 100);
  };

  return (
    <div id="resizeBtn">
      <Row>
        <Col span={8}>
          <span>Khoảng cách</span>
        </Col>

        <Col span={16}>
          <IntegerSlider
            id="space"
            defaultValue={config.space}
            step={0.5}
            min={1}
            max={5}
            callback={onChangeSpacingFactor}
          />
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <span>Kích cỡ</span>
        </Col>

        <Col span={16}>
          <IntegerSlider
            id="size"
            defaultValue={config.size / 100}
            step={0.5}
            min={0.5}
            max={5}
            callback={onChangeNodeWidth}
          />
        </Col>
      </Row>
    </div>
  );
};
export default ResizeBtn;
